import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const SellerInterface: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 3 }}>
        Interface do Vendedor
      </Typography>
      
      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Controle de Vendas e Metas
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Esta página será implementada com interface para vendedores,
            permitindo registrar vendas, acompanhar metas e visualizar gráficos de performance.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SellerInterface;
